import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const SetOccupiedIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M7.83,11.19c-.44.44-.44,1.15,0,1.59l5.25,5.25c.44.44,1.15.44,1.59,0,.44-.44.44-1.15,0-1.59l-3.33-3.33h11.53c.62,0,1.12-.5,1.12-1.12s-.5-1.12-1.12-1.12h-11.53l3.33-3.33c.44-.44.44-1.15,0-1.59s-1.15-.44-1.59,0l-5.25,5.24ZM22.5,3.38c0-1.87-1.51-3.38-3.37-3.38H3.37C1.51,0,0,1.51,0,3.38v17.25c0,1.87,1.51,3.38,3.37,3.38h15.75c1.87,0,3.37-1.51,3.37-3.38v-.38c0-.62-.5-1.12-1.12-1.12s-1.12.5-1.12,1.12v.38c0,.62-.5,1.12-1.12,1.12H3.37c-.62,0-1.12-.5-1.12-1.12V3.38c0-.62.5-1.12,1.12-1.12h15.75c.62,0,1.12.5,1.12,1.12v.38c0,.62.5,1.12,1.12,1.12s1.12-.5,1.12-1.12v-.38Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default SetOccupiedIcon
